export default __webpack_public_path__ + "static/media/Tabl_10.1b487f8a.svg";